export const FIELD_CONTRACT_KEY = '__field_contract';

const FIELD_ID_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;
const TARGET_PATTERN = /^[A-Za-z][A-Za-z0-9_]{0,127}$/;

const hasValue = (value) =>
	value !== null &&
	value !== undefined &&
	(typeof value !== 'string' || Boolean(value.trim()));

const sourceValue = (values, fieldId, source) => {
	switch (source) {
		case 'value':
			return values[fieldId];
		case 'choice_value':
			return values[`${fieldId}_frontend_value`];
		case 'reference_id':
			return values[`${fieldId}_id`];
		case 'presence':
			return hasValue(values[fieldId]);
		default:
			return undefined;
	}
};

const decodeValue = (value, codec) => {
	if (codec === 'string') return String(value);
	if (codec === 'boolean') {
		if (value === true || value === 'true') return true;
		if (value === false || value === 'false') return false;
		return undefined;
	}
	return value;
};

/**
 * Apply a validated backend field contract to canonical modal values.
 * Returns null when no compatible contract is present so resource plugins can
 * use their compatibility mapper.
 * @param {object} values canonical agent modal values
 * @param {boolean} tip whether the mounted form uses TIP fields
 * @return {object|null} Canvas form patch or null
 */
export function mapFieldContract(values = {}, tip = false) {
	const contract = values?.[FIELD_CONTRACT_KEY];
	const expectedMode = tip ? 'tip' : 'non_tip';
	if (
		!contract ||
		contract.version !== 1 ||
		contract.mode !== expectedMode ||
		!contract.fields ||
		typeof contract.fields !== 'object'
	) {
		return null;
	}

	const patch = {};
	Object.entries(contract.fields).forEach(([fieldId, field]) => {
		if (
			!FIELD_ID_PATTERN.test(fieldId) ||
			field?.allowed === false ||
			field?.visible === false
		) return;
		const bindings = Array.isArray(field?.bindings) ? field.bindings : [];
		bindings.forEach((binding) => {
			if (!TARGET_PATTERN.test(binding?.target || '')) return;
			const value = sourceValue(values, fieldId, binding?.source);
			if (binding?.source === 'presence' && value !== true) return;
			if (!hasValue(value)) return;
			const decoded = decodeValue(value, binding?.codec);
			if (decoded === undefined) return;
			patch[binding.target] = decoded;
		});
	});
	return patch;
}
